import { debugMessage } from "../common";

const FORCE_SOURCE_INFLUX = "influx";

/** Session-only staff toggle from Dev Tools (not persisted). */
let staffForceSource = null;
let staffForceSourceHardwareIds = [];
const forceSourceListeners = new Set();

function _debug(message) {
  debugMessage(message, "staffForceSource");
}

function notifyForceSourceListeners() {
  forceSourceListeners.forEach((listener) => listener(staffForceSource));
}

export function setStaffForceSourceHardwareIds(hardwareIds) {
  staffForceSourceHardwareIds = Array.isArray(hardwareIds)
    ? hardwareIds.filter((id) => id != null && id !== "")
    : [];
}

async function clearChartCacheForForceSourceChange() {
  if (!staffForceSourceHardwareIds.length) return;

  const { clearChartCacheForHardwareId } = await import("./chartDataCache");
  await Promise.all(
    staffForceSourceHardwareIds.map((hardwareId) =>
      clearChartCacheForHardwareId(hardwareId),
    ),
  );
}

/** @param {(source: null | 'influx') => void} listener */
export function subscribeStaffForceSource(listener) {
  forceSourceListeners.add(listener);
  return () => forceSourceListeners.delete(listener);
}

/** @returns {null | 'influx'} */
export function getStaffForceSource() {
  return staffForceSource;
}

/** @param {null | 'influx'} source */
export async function setStaffForceSource(source) {
  const next = source === FORCE_SOURCE_INFLUX ? source : null;

  if (next === staffForceSource) return;

  staffForceSource = next;
  if (staffForceSource) {
    _debug(`force source set to ${staffForceSource}`);
  } else {
    _debug("force source cleared");
  }

  await clearChartCacheForForceSourceChange();
  notifyForceSourceListeners();
}

export function appendStaffForceSourceQuery(url) {
  if (!staffForceSource) return url;

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}forceSource=${encodeURIComponent(staffForceSource)}`;
}
